module.exports = __webpack_public_path__ + "static/media/CIAJflyers.443c512a.jpg";